export const LOAD_DATA_CONFIGS = 'LOAD_DATA_CONFIGS'
export const LOAD_DATA_CONFIGS_SUCCESS = 'LOAD_DATA_CONFIGS_SUCCESS'
export const LOAD_DATA_CONFIGS_FAILURE = 'LOAD_DATA_CONFIGS_FAILURE'

export const LOAD_BRANCHES = 'LOAD_BRANCHES_CONFIGS'
export const LOAD_BRANCHES_SUCCESS = 'LOAD_BRANCHES_SUCCESS'
export const LOAD_BRANCHES_FAILURE = 'LOAD_BRANCHES_FAILURE'
